import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";

import { Routing } from "./routes";
import { store } from "./redux";

import "./i18n";
import { createTheme } from "./theme";

import "@livekit/components-styles";

import "./index.css";
import "react-datasheet-grid/dist/style.css";

const router = createBrowserRouter([{ path: "*", element: <Routing /> }]);

function App() {
	return (
		<Provider store={store}>
			<ThemeProvider theme={createTheme({ colorPreset: "browserbite" })}>
				<CssBaseline />

				<RouterProvider router={router} />
			</ThemeProvider>
		</Provider>
	);
}

export default App;
